// PurchaseReceipt.js

import React, { useEffect, useRef, useState } from "react";
import { Modal, Switch, Select } from "antd";
import { useReactToPrint } from "react-to-print";
import Swal from "sweetalert2";
import "./PurchaseReciept.css";
import logo from "./zulu.png";

const { Option } = Select;

const PurchaseReceipt = ({
  open,
  onClose,
  receiptData = [],
  receiptTotal = 0,
  formatNumber,
}) => {
  const printRef = useRef(null);

  const [printerMode, setPrinterMode] = useState(
    localStorage.getItem("printerMode") || "thermal"
  );

  const [setDefaultPrinter, setSetDefaultPrinter] = useState(
    localStorage.getItem("setDefaultPrinter") === "true"
  );

  useEffect(() => {
    localStorage.setItem("printerMode", printerMode);
    localStorage.setItem(
      "setDefaultPrinter",
      setDefaultPrinter
    );
  }, [printerMode, setDefaultPrinter]);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,

    documentTitle: `Receipt-${Date.now()}`,

    onBeforeGetContent: () => {
      Swal.fire({
        title: "Preparing Receipt...",
        text: "Opening printer dialog...",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      return Promise.resolve();
    },

    onBeforePrint: () => {
      Swal.close();
    },

    onAfterPrint: () => {
      Swal.fire({
        icon: "success",
        title: "Print Complete",
        text: "Receipt sent to printer",
        timer: 2000,
        showConfirmButton: false,
      });
    },

    removeAfterPrint: true,
  });

  return (
    <Modal
      open={open}
      footer={null}
      onCancel={onClose}
      centered
      width={900}
      destroyOnClose
    >
      <div className="receipt-wrapper">

        {/* RECEIPT */}
        <div
          ref={printRef}
          className="receipt-preview"
        >
          <div className="receipt-header">

            <img
              src={logo}
              alt="logo"
              className="receipt-logo"
            />

            <h1 className="store-name">
              ZULUWHISKEY
            </h1>

            <h3 className="store-type">
              SHIPPING STORE
            </h3>

            <p>
              Tel: +231-773-275-388 |
              +231-889-239-865
            </p>

            <p>
              Johnsonville, Kpelleh Town,
              Opposite God's Willing Gas Station,
              Monrovia, Liberia
            </p>

          </div>

          <div className="receipt-body">

            {receiptData.length > 0 ? (
              receiptData.map((item, index) => (
                <div
                  key={index}
                  className="receipt-item"
                >
                  <span>
                    {item.product_name} ×{" "}
                    {item.quantity_taken}
                  </span>

                  <span>
                    ${formatNumber(item.total)}
                  </span>
                </div>
              ))
            ) : (
              <div className="no-items">
                No items found
              </div>
            )}

          </div>

          <div className="receipt-total">
            TOTAL: $
            {formatNumber(receiptTotal)}
          </div>

          <div className="receipt-footer">
            <p>
              THANK YOU FOR SHOPPING
              WITH US 🙏
            </p>

            <small>
              COME AGAIN SOON
            </small>
          </div>
        </div>

        {/* CONTROLS */}
        <div className="receipt-controls">

          <h3>Printer Settings</h3>

          <Select
            value={printerMode}
            onChange={setPrinterMode}
            style={{
              width: "100%",
              marginBottom: 15,
            }}
          >
            <Option value="thermal">
              80mm Thermal Printer
            </Option>

            <Option value="a4">
              A4 Printer
            </Option>
          </Select>

          <div style={{ marginBottom: 15 }}>
            <Switch
              checked={setDefaultPrinter}
              onChange={setSetDefaultPrinter}
            />{" "}
            Set as Default Printer
          </div>

          <button
            className="print-btn"
            onClick={() => {
              if (!printRef.current) {
                Swal.fire({
                  icon: "error",
                  title: "Print Error",
                  text:
                    "Receipt content not found.",
                });

                return;
              }

              handlePrint();
            }}
          >
            Print Receipt
          </button>

          <button
            className="close-btn"
            onClick={onClose}
          >
            Close
          </button>

        </div>

      </div>
    </Modal>
  );
};

export default PurchaseReceipt; 





















